export const LeadLangs = {
  REQUIRED_I_WOULD_LIKE: {
    en: 'Please select more details or to view a property',
  },
};
